/* mg-knappar: en meny ersätter knapparna när det finns 2+ val.
   Datorn får en egen stylad meny, mobilen behåller telefonens inbyggda väljare.
   Båda klickar på motsvarande knapp, så befintlig variantlogik används oförändrad. */
(function () {
  var MIN_OPTIONS = 2;
  var CHEVRON =
    '<svg class="mg-dd__chev" width="12" height="8" viewBox="0 0 12 8" aria-hidden="true">' +
    '<path d="M1 1.5l5 5 5-5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var openDropdown = null;

  function labelOf(badge) {
    return (badge.dataset.optionValue || badge.textContent).trim();
  }

  function enhance(group) {
    if (group.dataset.mgSelect) return;
    var badges = group.querySelectorAll('.variant-badge');
    if (badges.length < MIN_OPTIONS) return;
    group.dataset.mgSelect = '1';
    group.classList.add('mg-has-select');

    var active = 0;
    badges.forEach(function (badge, i) {
      if (badge.classList.contains('variant-badge--active')) active = i;
    });

    // Mobil: inbyggd väljare
    var select = document.createElement('select');
    select.className = 'mg-variant-select';
    select.setAttribute('aria-label', 'Nicotine strength');
    badges.forEach(function (badge, i) {
      var opt = document.createElement('option');
      opt.value = String(i);
      opt.textContent = labelOf(badge);
      select.appendChild(opt);
    });

    // Dator: egen meny
    var dd = document.createElement('div');
    dd.className = 'mg-dd';
    // div i stället för button: temat döljer alla knappar utom variant-badge för gäster
    var toggle = document.createElement('div');
    toggle.tabIndex = 0;
    toggle.setAttribute('role', 'button');
    toggle.className = 'mg-dd__toggle';
    toggle.setAttribute('aria-haspopup', 'listbox');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.innerHTML = '<span class="mg-dd__value"></span>' + CHEVRON;
    var list = document.createElement('ul');
    list.className = 'mg-dd__list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;
    badges.forEach(function (badge, i) {
      var li = document.createElement('li');
      li.className = 'mg-dd__option';
      li.setAttribute('role', 'option');
      li.dataset.index = String(i);
      li.textContent = labelOf(badge);
      list.appendChild(li);
    });
    dd.appendChild(toggle);
    dd.appendChild(list);

    function setActive(i) {
      active = i;
      select.value = String(i);
      toggle.querySelector('.mg-dd__value').textContent = labelOf(badges[i]);
      list.querySelectorAll('.mg-dd__option').forEach(function (li, j) {
        li.setAttribute('aria-selected', j === i ? 'true' : 'false');
      });
    }

    function choose(i) {
      if (badges[i] && !badges[i].classList.contains('variant-badge--active')) badges[i].click();
      setActive(i);
    }

    function open() {
      if (openDropdown && openDropdown !== close) openDropdown();
      list.hidden = false;
      dd.classList.add('is-open');
      group.classList.add('mg-open');
      toggle.setAttribute('aria-expanded', 'true');
      openDropdown = close;
      focusOption(active);
    }

    function close() {
      list.hidden = true;
      dd.classList.remove('is-open');
      group.classList.remove('mg-open');
      toggle.setAttribute('aria-expanded', 'false');
      if (openDropdown === close) openDropdown = null;
    }

    function focusOption(i) {
      list.querySelectorAll('.mg-dd__option').forEach(function (li, j) {
        li.classList.toggle('is-focused', j === i);
      });
      list.dataset.focus = String(i);
    }

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      list.hidden ? open() : close();
    });

    list.addEventListener('click', function (e) {
      e.stopPropagation();
      var li = e.target.closest('.mg-dd__option');
      if (!li) return;
      choose(Number(li.dataset.index));
      close();
      toggle.focus();
    });

    list.addEventListener('mousemove', function (e) {
      var li = e.target.closest('.mg-dd__option');
      if (li) focusOption(Number(li.dataset.index));
    });

    dd.addEventListener('keydown', function (e) {
      var count = badges.length;
      var f = Number(list.dataset.focus || active);
      if (list.hidden) {
        if (['ArrowDown', 'ArrowUp', 'Enter', ' '].indexOf(e.key) > -1) { e.preventDefault(); open(); }
        return;
      }
      if (e.key === 'ArrowDown') { e.preventDefault(); focusOption((f + 1) % count); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); focusOption((f - 1 + count) % count); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(f); close(); toggle.focus(); }
      else if (e.key === 'Escape' || e.key === 'Tab') { close(); }
    });

    select.addEventListener('change', function () {
      choose(Number(select.value));
    });

    // Håll menyerna i synk om knapparna ändras på annat sätt
    group.addEventListener('click', function (e) {
      var badge = e.target.closest('.variant-badge');
      if (!badge) return;
      var i = Array.prototype.indexOf.call(badges, badge);
      if (i > -1 && i !== active) setActive(i);
    });

    group.appendChild(select);
    group.appendChild(dd);
    setActive(active);
  }

  function scan(root) {
    (root || document).querySelectorAll('.product-card-wrapper .card__interactive').forEach(enhance);
  }

  function init() {
    scan(document);
    document.addEventListener('click', function () {
      if (openDropdown) openDropdown();
    });
    new MutationObserver(function (mutations) {
      for (var m of mutations) {
        for (var node of m.addedNodes) {
          if (node.nodeType === 1) scan(node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Startsidans introtext: på mobil visas tre rader och en "Read more"-knapp.
   Hela texten ligger kvar i HTML för SEO, den kortas bara visuellt. */
(function () {
  function initReadMore() {
    document.querySelectorAll('.trusted-brands__subheading').forEach(function (p) {
      if (p.dataset.mgReadMore) return;
      p.dataset.mgReadMore = '1';
      /* Första meningen syns, resten ligger i ett eget span som fälls ut (texten finns kvar i HTML) */
      if (!p.children.length) {
        var text = p.textContent.trim();
        var cut = text.indexOf('. ');
        if (cut > 0) {
          var first = document.createTextNode(text.slice(0, cut));
          var dot = document.createElement('span');
          dot.className = 'mg-readmore__dot';
          dot.textContent = '. ';
          var dots = document.createElement('span');
          dots.className = 'mg-readmore__dots';
          dots.setAttribute('aria-hidden', 'true');
          dots.textContent = '...';
          var rest = document.createElement('span');
          rest.className = 'mg-readmore__rest';
          rest.textContent = text.slice(cut + 2);
          p.textContent = '';
          p.appendChild(first);
          p.appendChild(dot);
          p.appendChild(dots);
          p.appendChild(rest);
        }
      }
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mg-readmore';
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = 'Read more';
      btn.addEventListener('click', function () {
        var open = p.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? 'Show less' : 'Read more';
      });
      p.insertAdjacentElement('afterend', btn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReadMore);
  } else {
    initReadMore();
  }
})();

/* Mobil: valutaväljaren (Bucks-appen) flyttas in i mobilmenyn i stället för att flyta i hörnet */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var home = null;

  function place() {
    var widget = document.querySelector('.buckscc-currency-wrapper');
    var slot = document.querySelector('.menu-drawer__utility-links');
    if (!widget || !slot) return;
    if (mq.matches) {
      if (!widget.classList.contains('mg-bucks-in-menu')) {
        home = home || { parent: widget.parentNode, next: widget.nextSibling };
        var wrap = slot.querySelector('.mg-bucks-slot');
        if (!wrap) {
          wrap = document.createElement('div');
          wrap.className = 'mg-bucks-slot';
          var label = document.createElement('span');
          label.className = 'mg-bucks-slot__label';
          label.textContent = 'Currency';
          wrap.appendChild(label);
          var account = slot.querySelector('.menu-drawer__account');
          if (account) account.insertAdjacentElement('afterend', wrap);
          else slot.prepend(wrap);
        }
        wrap.appendChild(widget);
        widget.classList.add('mg-bucks-in-menu');
      }
    } else if (widget.classList.contains('mg-bucks-in-menu') && home) {
      home.parent.insertBefore(widget, home.next && home.next.parentNode === home.parent ? home.next : null);
      widget.classList.remove('mg-bucks-in-menu');
    }
  }

  function start() {
    place();
    new MutationObserver(function () {
      if (document.querySelector('.buckscc-currency-wrapper:not(.mg-bucks-in-menu)') && mq.matches) place();
    }).observe(document.body, { childList: true, subtree: true });
    if (mq.addEventListener) mq.addEventListener('change', place);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* Telefon: en tom touchstart-lyssnare gör att Safari visar knapparnas :active-läge (tryck-animationerna i mg-style-b.css). */
document.addEventListener('touchstart', function () {}, { passive: true });
